/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_hist_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The number of bins is chosen automatically from the sample size.`)
};

const es_hist_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El número de intervalos se elige automáticamente según el tamaño de la muestra.`)
};

const de_hist_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Anzahl der Klassen wird automatisch aus der Stichprobengröße gewählt.`)
};

const nl_hist_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het aantal klassen wordt automatisch gekozen op basis van de steekproefgrootte.`)
};

const fr_hist_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le nombre de classes est choisi automatiquement en fonction de la taille de l'échantillon.`)
};

const it_hist_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il numero di classi viene scelto automaticamente in base alla dimensione del campione.`)
};

const pt_br2_hist_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O número de bins é escolhido automaticamente a partir do tamanho da amostra.`)
};

const pt_hist_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O número de classes é escolhido automaticamente a partir do tamanho da amostra.`)
};

const ja_hist_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ビンの数はサンプルサイズから自動的に選ばれます。`)
};

const zh_hist_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`箱数会根据样本量自动选择。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const hist_ex3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.hist_ex3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("hist_ex3", locale)
	if (locale === "en") return en_hist_ex3(inputs)
	if (locale === "es") return es_hist_ex3(inputs)
	if (locale === "de") return de_hist_ex3(inputs)
	if (locale === "nl") return nl_hist_ex3(inputs)
	if (locale === "fr") return fr_hist_ex3(inputs)
	if (locale === "it") return it_hist_ex3(inputs)
	if (locale === "pt-BR") return pt_br2_hist_ex3(inputs)
	if (locale === "pt") return pt_hist_ex3(inputs)
	if (locale === "ja") return ja_hist_ex3(inputs)
	return zh_hist_ex3(inputs)
};